/** Inline separator dot for marketing meta rows (hero, page header). */
export function Dot() {
	return (
		<span
			aria-hidden
			className="bg-muted-foreground/50 inline-block h-1 w-1 rounded-full"
		/>
	)
}
